module.exports = __webpack_public_path__ + "assets/Space-suit2Wa.77978616.svg";